import React, { useRef, useState } from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

interface AnnotationCanvasProps {
  specimenName: string;
  onSave: (imageDataUrl: string) => void;
}

const AnnotationCanvas: React.FC<AnnotationCanvasProps> = ({ specimenName, onSave }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [drawing, setDrawing] = useState(false);
  const [hasMarks, setHasMarks] = useState(false);

  const point = (event: React.PointerEvent<HTMLCanvasElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    return { x: ((event.clientX - rect.left) / rect.width) * 600, y: ((event.clientY - rect.top) / rect.height) * 300 };
  };
  const start = (event: React.PointerEvent<HTMLCanvasElement>) => {
    event.currentTarget.setPointerCapture(event.pointerId);
    const ctx = event.currentTarget.getContext('2d');
    if (!ctx) return;
    const p = point(event);
    ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.strokeStyle = '#a34c2e'; ctx.lineWidth = 3; ctx.lineCap = 'round';
    setDrawing(true); setHasMarks(true);
  };
  const move = (event: React.PointerEvent<HTMLCanvasElement>) => {
    if (!drawing) return;
    const ctx = event.currentTarget.getContext('2d');
    if (!ctx) return;
    const p = point(event); ctx.lineTo(p.x, p.y); ctx.stroke();
  };
  const finish = () => setDrawing(false);
  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (canvas && ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    setHasMarks(false);
  };

  return <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center"><Box><Typography variant="subtitle2" fontWeight={800}>Sketch and annotate</Typography><Typography variant="caption" color="text.secondary">Mark the specimen features you actually observed.</Typography></Box><Button size="small" onClick={clear}>Clear</Button></Stack>
    <Box sx={{ position: 'relative', mt: 1, border: '1px solid #cad8d3', borderRadius: 1, overflow: 'hidden', backgroundColor: '#fff' }}>
      <Typography variant="caption" sx={{ position: 'absolute', top: 6, left: 8, color: '#5a6b66' }}>{specimenName}</Typography>
      <canvas ref={canvasRef} width={600} height={300} aria-label={`Annotation canvas for ${specimenName}`} onPointerDown={start} onPointerMove={move} onPointerUp={finish} onPointerCancel={finish} style={{ display: 'block', width: '100%', height: 180, touchAction: 'none', cursor: 'crosshair' }} />
    </Box>
    <Button size="small" variant="outlined" sx={{ mt: 1 }} disabled={!hasMarks} onClick={() => { const data = canvasRef.current?.toDataURL('image/png'); if (data) onSave(data); }}>Save sketch to observation</Button>
  </Paper>;
};

export default AnnotationCanvas;
